(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var links = document.querySelectorAll('a');

    links.forEach(function(link) {
        if (link.textContent.trim() === "Cookie-Einstellungen") {
            link.addEventListener('click', function(event) {
                event.preventDefault();
                privacyBanner.showPreferences()
            });
        }
    });
});


  } catch(e) { console.error(e); }
})();
})();
